import { IconBase, type IconProps } from './IconBase';

export function RefreshIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M4 12a8 8 0 1 0 3-6.2" />
      <path d="M4 4v4h4" />
    </IconBase>
  );
}
